import React from 'react'
import { Spinner } from "react-bootstrap";

function LoaderBtn(props) {
    return (
        <div>
            <Spinner
                className={ props.loads ===true ? 'visually mx-1' : 'visually-hidden'}
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
            />
        </div>
    )
}

export default LoaderBtn